import React from "react"
import Link from "next/link"

import { accordionUniqueId, getPdpRedirectUrl } from "@/utils/index"
import { getPdpUrlPath } from "@/utils/helper"

import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import Style from "@/components/MultiFinshProductBundle/styles/BundleDetailsAccordianUI.module.scss"

import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import Collapsible from "react-collapsible"
import CollapsibleHeader from "@/components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader"

import {
  accordianClickBundleFeature,
  viewMoreBundleFeature,
} from "@/components/MultiFinshProductBundle/analytics"

const BundleFeaturesUI = props => {
  const { data = [], label = "", productInfoBundle = {} } = props || {}

  const getViewMoreLink = (category, slug, sku) => {
    if (category && slug && sku) {
      const pdpUrl = getPdpUrlPath(category, slug)
      const param = sku ? `skuId=${sku}` : ""
      return getPdpRedirectUrl(pdpUrl, param) || ""
    } else return ""
  }

  const { t } = useTranslation("common")
  const { viewMoreLabel = "" } = getTranslations(t)

  const getProductBadgeInfo = icon => {
    const watersenseList = icon.split("|")
    return watersenseList[2] || []
  }

  const handleOpenAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "expand",
      productInfoBundle
    )
  }
  const handleCloseAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "collapse",
      productInfoBundle
    )
  }

  const viewMoreBundleFeatureClick = (url = "") => {
    viewMoreBundleFeature(url, productInfoBundle)
  }

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${Style.BundlesDetailsAccordianUI} container-fluid`}
    >
      <div
        className={`collapsible-accordion bundle-accordian-section ${label.toLowerCase()}`}
        data-testid={`bundle-product-accordion-${label}`}
      >
        <Collapsible
          trigger={<CollapsibleHeader title={label} />}
          onTriggerOpening={() => handleOpenAccordian(label)}
          onTriggerClosing={() => handleCloseAccordian(label)}
          triggerOpenedClassName="collapsible__trigger--open"
          open={false}
          openedClassName="collapsible--open"
          transitionTime={400}
          tabIndex="0"
          easing="ease-in-out"
          triggerElementProps={{
            id: accordionUniqueId("collapsible-trigger", 9999, 1000),
          }}
          contentElementId={accordionUniqueId(
            "collapsible-content",
            9999,
            1000
          )}
        >
          {data.map(item => {
            const {
              category,
              slug,
              productWebFeatures = [],
              productBadgeInfo = [],
            } = item || {}

            const linkUrl = getViewMoreLink(category, slug, item.selectededSku)

            return productWebFeatures?.length ? (
              <div
                key={item.selectededSku}
                className={`col-12 ${Style.accordianContainer}`}
              >
                <p className="sku-title">{item.customerFacingSku}</p>
                <p className="title">{item.title}</p>
                <ul className="lists">
                  {item.productWebFeatures.slice(0, 5).map((fl, i) => (
                    <li key={"product-key-" + i}>{fl}</li>
                  ))}
                </ul>
                <Link
                  className="link"
                  href={linkUrl}
                  onClick={() => viewMoreBundleFeatureClick(linkUrl)}
                >
                  {viewMoreLabel}
                </Link>
                {productBadgeInfo.length ? (
                  <div className="icons">
                    {productBadgeInfo.map((icon, i) => (
                      <img
                        key={"image" + i}
                        src={getProductBadgeInfo(icon)}
                        alt="watersense icon"
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            ) : null
          })}
        </Collapsible>
      </div>
    </div>
  )
}
export default BundleFeaturesUI
